import { render } from "./LinkPage.vue?vue&type=template&id=f952ed4a&ts=true"
import script from "./LinkPage.vue?vue&type=script&lang=ts"
export * from "./LinkPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__